import Component from './component';
import { InputStyles } from './types';

Component.defaultProps = {
    className: null,
    placeholder: null,
    value: '',
    style: InputStyles.Primary,
    styles: {},
    error: null,
    disabled: false,
    decoratorLeft: null,
    decoratorRight: null,
};

export default Component;